import React, { Suspense } from 'react';
import { MomentInput } from 'moment';
import moment from 'moment-timezone';
import { DateDisplayOption } from './formatted-time-window';

const FormattedTimeWindow = React.lazy(() => import('./formatted-time-window'));
const FormatDateTimezone = React.lazy(() => import('./format-date-timezone'));
interface Props {
	date: MomentInput;
	format?: string;
	invalidDateText?: string;
	className?: string;
	timezone?: string;
}
export const getTimeFormat = (hourFormat = 'LT') => hourFormat;
export const getDateFormat = (hourFormat = 'LT') => `MMM DD, YYYY, ${hourFormat}`;
export const getOnlyDateFormat = () => `MMM DD, YYYY`;
export const getIsSameDay = (firstDate: MomentInput, secondDate: MomentInput, timezone?: string): boolean => {
	const firstDateWithTimezone = timezone ? moment(firstDate).tz(timezone) : moment(firstDate);
	const secondDateWithTimezone = timezone ? moment(secondDate).tz(timezone) : moment(secondDate);

	return moment(firstDateWithTimezone).isSame(secondDateWithTimezone, 'day');
};

export enum LayoutType {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical',
	INLINE = 'inline'
}

export const INVALID_DATE = '--:--';
export const getFormattedTimeWindow = (
	firstDate: MomentInput | string,
	secondDate: MomentInput | string,
	hourFormat: string,
	timezone?: string,
	template: LayoutType = LayoutType.VERTICAL,
	invalidDateText?: string,
	dateDisplayType = DateDisplayOption.SHOW_ONLY_FIRST_DATE_WHEN_SAME_DAY,
	dateFormat?: string
) => {
	return (
		<Suspense fallback={<div>Loading...</div>}>
			<FormattedTimeWindow
				firstDate={firstDate}
				secondDate={secondDate}
				hourFormat={hourFormat}
				timezone={timezone}
				template={template}
				invalidDateText={invalidDateText}
				dateDisplayType={dateDisplayType}
				dateFormat={dateFormat}
			/>
		</Suspense>
	);
};

const DateDisplay: React.FC<Props> = ({ date, format, invalidDateText = INVALID_DATE, className, timezone }) => {
	return (
		<span className={className}>
			{date ? (
				<Suspense fallback={<div>Loading...</div>}>
					<FormatDateTimezone date={date} format={format} timezone={timezone} />
				</Suspense>
			) : (
				invalidDateText
			)}
		</span>
	);
};

export default DateDisplay;
